const enBilling = {
    // Pricing page
    pricingEyebrow: "SCORE VISION",
    pricingTitle: "Choose your plan",
    pricingSubtitle: "Activated as soon as the payment is confirmed",
    recommendedBadge: "RECOMMENDED",
    subscribe: "Subscribe",
    currentPlan: "Your current plan",
    renewPlan: "Renew",
    saveVsStandard: "Save {{percent}}% (vs Standard)",
    currencyLabel: "FCFA",

    standardDuration: "1 WEEK",
    premiumDuration: "2 WEEKS",
    platinumDuration: "1 MONTH",

    standardTagline: "To put the AI algorithms to the test",
    premiumTagline: "The right fit for regular bettors",
    platinumTagline: "The unlimited VIP experience",

    standardFeaturePredictions: "2 AI predictions per day",
    standardFeatureAccess: "1 week of full access",
    standardFeatureSupport: "Email support",

    premiumFeatureEverythingStandard: "Everything in Standard, plus:",
    premiumFeaturePredictions: "5 AI predictions per day",
    premiumFeatureAccess: "2 weeks of full access",
    premiumFeatureHistory: "Full prediction history",
    premiumFeatureAlerts: "Live match alerts",

    platinumFeatureEverythingPremium: "Everything in Premium, plus:",
    platinumFeaturePredictions: "UNLIMITED AI predictions / day",
    platinumFeatureVip: "1 hand-picked VIP prediction / day",
    platinumFeatureAccess: "1 month of access (30 days)",
    platinumFeatureStats: "Detailed statistics & analyses",
    platinumFeatureOdds: "Odds comparison table",
    platinumFeatureSupport: "Priority support 24/7",

    // Checkout
    /** Ikeepay collects the payment, so the methods are its own */
    paymentMethodsNotice: "Mobile money (MTN, Orange) and bank cards are accepted. The payment opens in a secure Ikeepay window.",
    checkoutTitle: "Payment",
    checkoutSubtitle: "Pay by mobile money or card, your plan is activated as soon as it goes through",
    orderSummary: "Order summary",
    totalLabel: "Total",
    discountApplied: "{{percent}}% referral discount applied",
    changePlan: "Change plan",
    backToPlans: "Back to the plans",
    payNow: "Pay {{amount}}",
    paymentTerms: "By continuing, you authorise a payment of {{amount}}. The payment is collected by Ikeepay, our payment provider.",
    loadingCheckout: "Preparing the payment",
    checkoutUnavailable: "Payment is unavailable for the moment, please try again shortly",

    // Payment result
    paymentPendingTitle: "Payment in progress",
    paymentPendingDescription: "Your payment is being confirmed. This page updates on its own.",
    paymentSuccessTitle: "Payment confirmed",
    paymentSuccessDescription: "Your plan is active. Enjoy your analyses!",
    paymentFailedTitle: "Payment failed",
    paymentFailedDescription: "The payment did not go through. Nothing was charged, you can try again.",
    paymentCancelledTitle: "Payment cancelled",
    paymentCancelledDescription: "The request was cancelled. You can start the payment again whenever you like.",
    paymentTimeoutTitle: "Still waiting",
    paymentTimeoutDescription: "The payment has not been confirmed yet. Check where it stands.",
    checkPaymentStatus: "Check the status",
    paymentProcessingNotice: "A mobile money payment can take a minute",
    startAnalyzing: "Analyse a match"
}

export default enBilling
